import { LanguageWorkerContribution, EditorHandlerContribution, LanguageWorkerRegistry, LanguageOptionsRegistry } from '@alipay/e2-editor-contribution';
export { EditorHandlerContribution, LanguageOptionsRegistry, LanguageWorkerContribution, LanguageWorkerRegistry } from '@alipay/e2-editor-contribution';
import { Syringe, singleton, contrib, DefaultContributionProvider, inject, Module, decorate, injectable, Contribution, GlobalContainer } from '@alipay/mana-syringe';
import { Deferred, DisposableCollection, Disposable } from '@alipay/mana-common';
import { debug as debug$1 } from 'debug';
import 'reflect-metadata';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}
function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var EditorProvider = Symbol('EditorProvider');

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

var InitializeContribution = Syringe.defineToken('InitializeContribution');
var InitializeProvider = /*#__PURE__*/function () {
  function InitializeProvider(provider) {
    _classCallCheck(this, InitializeProvider);
    this.provider = void 0;
    this.provider = provider;
  }
  _createClass(InitializeProvider, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(coreMonaco) {
        var contributions, _iterator, _step, contribution, inited;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              contributions = this.provider.getContributions();
              _iterator = _createForOfIteratorHelper(contributions);
              _context.prev = 2;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context.next = 20;
                break;
              }
              contribution = _step.value;
              if (!contribution.onInitialize) {
                _context.next = 18;
                break;
              }
              _context.prev = 7;
              if (contribution.initialized) {
                _context.next = 14;
                break;
              }
              inited = contribution.onInitialize(coreMonaco);
              if (!inited) {
                _context.next = 13;
                break;
              }
              _context.next = 13;
              return inited;
            case 13:
              contribution.initialized = true;
            case 14:
              _context.next = 18;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](7);
            case 18:
              _context.next = 4;
              break;
            case 20:
              _context.next = 25;
              break;
            case 22:
              _context.prev = 22;
              _context.t1 = _context["catch"](2);
              _iterator.e(_context.t1);
            case 25:
              _context.prev = 25;
              _iterator.f();
              return _context.finish(25);
            case 28:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 22, 25, 28], [7, 16]]);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }]);
  return InitializeProvider;
}();
InitializeProvider = __decorate([singleton(), __param(0, contrib(InitializeContribution)), __metadata("design:paramtypes", [Object])], InitializeProvider);
var InitializeContributionProvider = /*#__PURE__*/function (_DefaultContributionP) {
  _inherits(InitializeContributionProvider, _DefaultContributionP);
  var _super = _createSuper(InitializeContributionProvider);
  function InitializeContributionProvider() {
    _classCallCheck(this, InitializeContributionProvider);
    return _super.apply(this, arguments);
  }
  _createClass(InitializeContributionProvider, [{
    key: "getContributions",
    value: function getContributions() {
      this.services = undefined;
      return _get(_getPrototypeOf(InitializeContributionProvider.prototype), "getContributions", this).call(this);
    }
  }]);
  return InitializeContributionProvider;
}(DefaultContributionProvider);

var debug = debug$1('[editor-core]');

var dlog = debug.extend('monaco-loader');
var DefaultLoaderConfig = {
  useLocal: false,
  requireConfig: {
    'vs/nls': {
      availableLanguages: {
        '*': 'zh-cn'
      }
    },
    paths: {
      // vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.23.0/min/vs',
      // vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.20.0/min/vs',
      // vs: 'https://cdn.jsdelivr.net/npm/monaco-editor-core@0.23.0/dev/vs',
      // vs: 'https://gw.alipayobjects.com/os/lib/alipay/monaco-editor-core/0.23.1/min/vs',
      vs: 'https://gw.alipayobjects.com/os/lib/alipay/monaco-editor-core/0.31.1-es6-4/min/vs',
      // vs: 'https://cdn.jsdelivr.net/npm/monaco-editor-core@0.31.1/min/vs',
      'monaco-vim': 'https://gw.alipayobjects.com/os/lib/alipay/monaco-vim/1.0.0/dist/monaco-vim.js'
    }
  }
};
var MonacoLoaderConfig = Symbol('MonacoLoaderConfig');
var MonacoLoader = /*#__PURE__*/function () {
  function MonacoLoader(config) {
    _classCallCheck(this, MonacoLoader);
    this.config = void 0;
    this.loaded = false;
    this.start = false;
    this.loadDeferred = new Deferred();
    this.vsRequire = void 0;
    this.config = config;
  }
  _createClass(MonacoLoader, [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var start;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              start = new Date().getTime();
              if (!this.start) {
                this.start = true;
                dlog('time: before doLoad', new Date().getTime() - start);
                this.doLoad();
                dlog('time: after doLoad', new Date().getTime() - start);
              }
              return _context.abrupt("return", this.loadDeferred.promise);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "doLoad",
    value: function () {
      var _doLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var start, vsRequire, end;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              start = new Date().getTime();
              if (this.loaded) {
                _context2.next = 8;
                break;
              }
              _context2.next = 4;
              return this.getLoader(window);
            case 4:
              vsRequire = _context2.sent;
              _context2.next = 7;
              return this.loadMonaco(vsRequire);
            case 7:
              this.loadDeferred.resolve(monaco);
            case 8:
              end = new Date().getTime();
              dlog('time: monaco-load', end - start);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function doLoad() {
        return _doLoad.apply(this, arguments);
      }
      return doLoad;
    }()
  }, {
    key: "getLoader",
    value: function getLoader(context) {
      var _this = this;
      var originalRequire = context.require;
      return new Promise(function (resolve) {
        var vsLoader = document.createElement('script');
        vsLoader.type = 'text/javascript';
        vsLoader.charset = 'utf-8';
        var srcParent = _this.config.useLocal ? './vs' : _this.config.requireConfig.paths.vs;
        vsLoader.src = srcParent.endsWith('/') ? "".concat(srcParent, "loader.js") : "".concat(srcParent, "/loader.js");
        vsLoader.addEventListener('load', function () {
          // Save Monaco's amd require and restore the original require
          var amdRequire = context.require;
          if (!context.__e2_require) context.__e2_require = amdRequire;
          context.require = originalRequire;
          _this.vsRequire = amdRequire || context.__e2_require;
          _this.vsRequire.config(_this.config.requireConfig);
          resolve(amdRequire);
        });
        var fragment = document.createDocumentFragment();
        fragment.appendChild(vsLoader);
        document.body.appendChild(fragment);
      });
    }
  }, {
    key: "loadMonaco",
    value: function loadMonaco() {
      var _this2 = this;
      var vsRequire = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.vsRequire;
      return new Promise(function (resolve) {
        if (!vsRequire) {
          resolve();
        }
        vsRequire(['vs/editor/editor.main'], function () {
          var requires = ['vs/platform/commands/common/commands', 'vs/platform/actions/common/actions', 'vs/platform/keybinding/common/keybindingsRegistry', 'vs/platform/keybinding/common/keybindingResolver', 'vs/platform/keybinding/common/usLayoutResolvedKeybinding', 'vs/base/common/keybindingLabels', 'vs/base/common/keyCodes', 'vs/base/common/mime', 'vs/editor/browser/editorExtensions', 'vs/editor/standalone/browser/simpleServices', 'vs/editor/standalone/browser/standaloneServices', 'vs/editor/standalone/browser/standaloneLanguages',
          // 'vs/base/parts/quickopen/browser/quickOpenWidget',
          // 'vs/base/parts/quickopen/browser/quickOpenModel',
          'vs/base/common/filters', 'vs/platform/theme/common/themeService', 'vs/platform/theme/common/styler', 'vs/platform/theme/common/colorRegistry', 'vs/base/common/color', 'vs/base/common/platform', 'vs/editor/common/modes', 'vs/editor/contrib/suggest/suggest', 'vs/editor/contrib/snippet/snippetParser', 'vs/editor/contrib/format/format', 'vs/platform/configuration/common/configuration', 'vs/platform/configuration/common/configurationModels', 'vs/editor/common/services/resolverService', 'vs/editor/browser/services/codeEditorService', 'vs/editor/browser/services/codeEditorServiceImpl', 'vs/editor/browser/services/openerService', 'vs/platform/markers/common/markerService', 'vs/platform/contextkey/common/contextkey', 'vs/platform/contextkey/browser/contextKeyService', 'vs/editor/common/model/wordHelper', 'vs/base/common/errors', 'vs/base/common/path', 'vs/editor/common/model/textModel', 'vs/base/common/strings', 'vs/base/common/async', 'vs/editor/standalone/common/monarch/monarchLexer', 'vs/editor/contrib/hover/modesContentHover', 'vs/editor/browser/widget/codeEditorWidget', 'vs/base/browser/dompurify/dompurify', 'vs/editor/contrib/folding/foldingModel'];
          if (_this2.config.requireConfig.paths['monaco-vim']) {
            requires.push('monaco-vim');
          }
          vsRequire(requires, function (commands, actions, keybindingsRegistry, keybindingResolver, resolvedKeybinding, keybindingLabels, keyCodes, mime, editorExtensions, simpleServices, standaloneServices, standaloneLanguages,
          // quickOpenWidget: any,
          // quickOpenModel: any,
          filters, themeService, styler, colorRegistry, color, platform, modes, suggest, snippetParser, format, configuration, configurationModels, resolverService, codeEditorService, codeEditorServiceImpl, openerService, markerService, contextKey, contextKeyService, wordHelper, error, path, textModel, strings, async, monarchLexer, modesContentHover, codeEditorWidget, dompurify, foldingModel, monacoVim) {
            window.MonacoVim = monacoVim;
            // eslint-disable-next-line no-restricted-globals
            var global = self;
            global.monaco.commands = commands;
            global.monaco.actions = actions;
            global.monaco.keybindings = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, keybindingsRegistry), keybindingResolver), resolvedKeybinding), keybindingLabels), keyCodes);
            global.monaco.services = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, simpleServices), standaloneServices), standaloneLanguages), configuration), configurationModels), resolverService), codeEditorService), codeEditorServiceImpl), markerService), openerService);
            global.monaco.quickOpen = {
              // quickOpenWidget,
              // quickOpenModel,
            };
            global.monaco.filters = filters;
            global.monaco.theme = _objectSpread2(_objectSpread2({}, themeService), styler);
            global.monaco.color = _objectSpread2(_objectSpread2({}, colorRegistry), color);
            global.monaco.platform = platform;
            global.monaco.editorExtensions = editorExtensions;
            global.monaco.modes = modes;
            global.monaco.suggest = suggest;
            global.monaco.snippetParser = snippetParser;
            global.monaco.format = format;
            global.monaco.contextkey = contextKey;
            global.monaco.contextKeyService = contextKeyService;
            global.monaco.mime = mime;
            global.monaco.wordHelper = wordHelper;
            global.monaco.error = error;
            global.monaco.path = path;
            global.monaco.textModel = textModel;
            global.monaco.strings = strings;
            global.monaco.async = async;
            global.monaco.foldingModel = foldingModel;
            var beforeMyTokenize = monarchLexer.MonarchTokenizer.prototype._myTokenize;
            monarchLexer.MonarchTokenizer.prototype._myTokenize = function _myTokenize() {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              /** 根据日志一行可能会有好几次，一次渲染会半小时以上，这边一行字符数超过1w时，不做着色处理 */
              if (args[0].length > 10000) {
                return args[2];
              }
              return beforeMyTokenize.call.apply(beforeMyTokenize, [this].concat(args));
            };
            global.monaco.monarchLexer = monarchLexer;
            // Hover信息, 将报错信息前置
            var originalUpdateContents = modesContentHover.ModesContentHoverWidget.prototype._updateContents;
            modesContentHover.ModesContentHoverWidget.prototype._updateContents = function () {
              for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
              }
              var node = args[0];
              if (node.childNodes.length >= 3) {
                var prependNodes = [];
                for (var i = node.childNodes.length - 1; i >= 0; i--) {
                  var child = node.childNodes[i];
                  if (!child.className.includes('hover-row markdown-hover')) prependNodes.push(child);
                }
                prependNodes.forEach(function (child) {
                  return node.prepend(child);
                });
              }
              return originalUpdateContents.apply(this, args);
            };
            // 语言hover自定义html白名单
            var originalAddHook = dompurify.addHook;
            dompurify.addHook = function () {
              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }
              if (args[0] === 'uponSanitizeAttribute') {
                originalAddHook.apply(this, ['uponSanitizeAttribute', function (element, e) {
                  var parentElement = element;
                  while (parentElement) {
                    if (parentElement.dataset.dangerouslySetInnerHtml) return;else parentElement = parentElement.parentElement;
                  }
                  if (e.attrName === 'style' || e.attrName === 'class') {
                    if (element.tagName === 'SPAN') {
                      if (e.attrName === 'style') {
                        e.keepAttr = /^(color\:#[0-9a-fA-F]+;)?(background-color\:#[0-9a-fA-F]+;)?$/.test(e.attrValue);
                        return;
                      } else if (e.attrName === 'class') {
                        e.keepAttr = /^codicon codicon-[a-z\-]+( codicon-modifier-[a-z\-]+)?$/.test(e.attrValue);
                        return;
                      }
                    }
                    e.keepAttr = false;
                    return;
                  }
                }]);
                return;
              }
              return originalAddHook.apply(this, args);
            };
            var originalSanitize = dompurify.sanitize;
            dompurify.sanitize = function () {
              for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
              }
              if (args[0].includes('data-dangerously-set-inner-html')) return args[0];
              return originalSanitize.apply(this, args);
            };
            _this2.loaded = true;
            resolve();
          });
        });
      });
    }
  }]);
  return MonacoLoader;
}();
MonacoLoader = __decorate([singleton(), __param(0, inject(MonacoLoaderConfig)), __metadata("design:paramtypes", [Object])], MonacoLoader);

var MonacoConfigurationService = Symbol('MonacoConfigurationService');
function createMonacoConfigurationService(container) {
  var service = monaco.services.StaticServices.configurationService.get();
  var _configuration = service._configuration;
  // @ts-ignore
  _configuration.getValue = function (section, overrides) {
    return undefined;
  };
  return service;
}

var DefaultWorkerContribution = /*#__PURE__*/function () {
  function DefaultWorkerContribution(config) {
    _classCallCheck(this, DefaultWorkerContribution);
    this.config = void 0;
    this.config = config;
  }
  _createClass(DefaultWorkerContribution, [{
    key: "registerLanguageWorkers",
    value: function registerLanguageWorkers(registry) {
      registry.registerWorker({
        language: 'editorWorkerService',
        getWorkerUrl: this.getWorkerUrl.bind(this)
      });
    }
  }, {
    key: "getWorkerUrl",
    value: function getWorkerUrl(moduleId) {
      if (!this.config.useLocal) {
        var vsUrl = this.config.requireConfig.paths.vs;
        if (moduleId === 'editorWorkerService') {
          // 默认worker.js
          return "data:text/javascript;charset=utf-8,".concat(encodeURIComponent("importScripts('".concat(vsUrl, "/base/worker/workerMain.js')")));
        }
        return "data:text/javascript;charset=utf-8,".concat(encodeURIComponent("importScripts('".concat(vsUrl, "/base/worker/").concat(moduleId, "')")));
      }
      // TODO: 本地加载模式下的 worker 加载要重新，需要考虑 baseUrl 等因素
      return "vs/base/worker/".concat(moduleId);
    }
  }]);
  return DefaultWorkerContribution;
}();
DefaultWorkerContribution = __decorate([singleton({
  contrib: LanguageWorkerContribution
}), __param(0, inject(MonacoLoaderConfig)), __metadata("design:paramtypes", [Object])], DefaultWorkerContribution);

// import { MonacoEnvironment } from './monaco-environment';
// export const EditorHandlerContribution = Syringe.defineToken('LanguageWorkerContribution');
// export interface EditorHandlerContribution extends Disposable {
//   beforeCreate: (coreMonaco: typeof monaco) => void;
//   afterCreate: (
//     editor: monaco.editor.IStandaloneCodeEditor | monaco.editor.IStandaloneDiffEditor,
//     coreMonaco: typeof monaco,
//   ) => void;
//   canHandle: (language: string) => boolean;
// }
var EditorHanlerRegistry = /*#__PURE__*/function () {
  function EditorHanlerRegistry(provider) {
    _classCallCheck(this, EditorHanlerRegistry);
    this.provider = void 0;
    this.contributions = void 0;
    this.effected = [];
    this.provider = provider;
    this.contributions = provider.getContributions();
  }
  _createClass(EditorHanlerRegistry, [{
    key: "handleAfter",
    value: function handleAfter(languege, editor) {
      var _this = this;
      this.effected.forEach(function (contribution) {
        return contribution.dispose();
      });
      this.effected = [];
      var canHanleList = this.contributions.filter(function (handler) {
        return handler.canHandle(languege);
      });
      canHanleList.forEach(function (contribution) {
        contribution.afterCreate(editor, monaco);
        _this.effected.push(contribution);
      });
    }
  }, {
    key: "handleBefore",
    value: function handleBefore(languege) {
      var _this2 = this;
      // TODO 待修改
      this.effected.forEach(function (contribution) {
        return contribution.dispose();
      });
      this.effected = [];
      var canHanleList = this.contributions.filter(function (handler) {
        return handler.canHandle(languege);
      });
      canHanleList.forEach(function (contribution) {
        contribution.beforeCreate(monaco);
        _this2.effected.push(contribution);
      });
    }
  }]);
  return EditorHanlerRegistry;
}();
EditorHanlerRegistry = __decorate([singleton(), __param(0, contrib(EditorHandlerContribution)), __metadata("design:paramtypes", [Object])], EditorHanlerRegistry);

var ThemeContribution = Syringe.defineToken('ThemeContribution');
var MixedThemeRegistry = Symbol('MixedThemeRegistry');
var ThemeRegistry = /*#__PURE__*/function () {
  function ThemeRegistry(provider, mixedThemeRegistry) {
    _classCallCheck(this, ThemeRegistry);
    this.provider = void 0;
    this.mixedThemeRegistry = void 0;
    this.contributions = void 0;
    this.themeOptions = {};
    this.themes = new Map();
    this.provider = provider;
    this.mixedThemeRegistry = mixedThemeRegistry;
    this.contributions = this.provider.getContributions();
  }
  _createClass(ThemeRegistry, [{
    key: "onInitialize",
    value: function onInitialize() {
      var _this = this;
      this.contributions.forEach(function (item) {
        item.registerItem(_this);
      });
      if (this.mixedThemeEnable) {
        this.mixedThemeRegistry.registerThemes(this.themeOptions, this.setTheme.bind(this));
      }
    }
  }, {
    key: "mixedThemeEnable",
    get: function get() {
      return !!(this.mixedThemeRegistry && this.mixedThemeRegistry.registerThemes);
    }
  }, {
    key: "setTheme",
    value: function setTheme(name, data) {
      try {
        this.themes.set(name, data);
        // monaco auto refreshes a theme with new data
        monaco.editor.defineTheme(name, data);
      } catch (ex) {
        console.log(ex);
      }
    }
  }, {
    key: "registerMonacoTheme",
    value: function registerMonacoTheme(setting, name, monacoBase) {
      this.setTheme(name, _objectSpread2(_objectSpread2({}, setting), {}, {
        base: monacoBase || setting.base || 'vs'
      }));
    }
  }, {
    key: "registerMixedTheme",
    value: function registerMixedTheme(setting, givenName, givenBase) {
      var name = givenName || setting.name;
      this.themeOptions[givenName] = _objectSpread2(_objectSpread2({}, setting), {}, {
        givenName: givenName,
        name: name,
        base: givenBase
      });
    }
  }]);
  return ThemeRegistry;
}();
ThemeRegistry = __decorate([singleton({
  contrib: InitializeContribution
}), __param(0, contrib(ThemeContribution)), __param(1, inject(MixedThemeRegistry)), __metadata("design:paramtypes", [Object, Object])], ThemeRegistry);

var EditorNode = Symbol('EditorNode');
var MonacoOptions = Symbol('MonacoOptions');
var IsDiff = Symbol('IsDiff');
/**
 * E2 Editor
 */
var E2Editor = /*#__PURE__*/function () {
  function E2Editor(node, options, editorHandlerRegistry, themeRegistry, isDiff) {
    var _this = this;
    _classCallCheck(this, E2Editor);
    this.node = void 0;
    this.options = void 0;
    this.editorHandlerRegistry = void 0;
    this.themeRegistry = void 0;
    this.isDiff = void 0;
    this.codeEditor = void 0;
    this.model = void 0;
    this.modified = void 0;
    this.original = void 0;
    this.language = void 0;
    this.toDispose = new DisposableCollection();
    this.node = node;
    this.options = options;
    this.editorHandlerRegistry = editorHandlerRegistry;
    this.themeRegistry = themeRegistry;
    this.isDiff = isDiff;
    // create前钩子函数调用
    this.handleEditorLanguageFeatureBefore(options.language);
    if (!isDiff) {
      this.model = monaco.editor.createModel(options.value || '', options.language);
      this.codeEditor = monaco.editor.create(node, _objectSpread2(_objectSpread2({}, options), {}, {
        model: this.model
      }));
      this.toDispose.push(this.model.onDidChangeLanguage(function (e) {
        _this.language = e.newLanguage;
      }));
      this.language = this.model.getLanguageId();
    } else {
      this.modified = monaco.editor.createModel(options.modified || '', options.language);
      this.original = monaco.editor.createModel(options.original || '', options.language);
      this.codeEditor = monaco.editor.createDiffEditor(node, _objectSpread2({}, options));
      this.codeEditor.setModel({
        original: this.original,
        modified: this.modified
      });
      this.toDispose.push(this.modified.onDidChangeLanguage(function (e) {
        _this.language = e.newLanguage;
      }));
      this.language = this.modified.getLanguageId();
    }
    // 创建后的钩子函数
    this.handleEditorLanguageFeatureAfter();
  }
  _createClass(E2Editor, [{
    key: "handleEditorLanguageFeatureBefore",
    value: function handleEditorLanguageFeatureBefore(language) {
      if (language) {
        this.editorHandlerRegistry.handleBefore(language);
      }
    }
  }, {
    key: "handleEditorLanguageFeatureAfter",
    value: function handleEditorLanguageFeatureAfter() {
      if (this.language) {
        this.editorHandlerRegistry.handleAfter(this.language, this.codeEditor);
      }
    }
  }]);
  return E2Editor;
}();
E2Editor = __decorate([singleton(), __param(0, inject(EditorNode)), __param(1, inject(MonacoOptions)), __param(2, inject(EditorHanlerRegistry)), __param(3, inject(ThemeRegistry)), __param(4, inject(IsDiff)), __metadata("design:paramtypes", [HTMLElement, Object, EditorHanlerRegistry, ThemeRegistry, Boolean])], E2Editor);

var MonacoSnippetSuggestion = /*#__PURE__*/function () {
  function MonacoSnippetSuggestion(snippet, range) {
    _classCallCheck(this, MonacoSnippetSuggestion);
    this.snippet = void 0;
    this.range = void 0;
    this.label = void 0;
    this.detail = void 0;
    this.sortText = void 0;
    this.noAutoAccept = true;
    this.kind = monaco.languages.CompletionItemKind.Snippet;
    this.insertTextRules = monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet;
    this.insertText = void 0;
    this.documentation = void 0;
    this.resolved = false;
    this.snippet = snippet;
    this.range = range;
    this.label = snippet.prefix;
    this.detail = "".concat(snippet.description || snippet.name, " (").concat(snippet.source, ")");
    this.insertText = snippet.body;
    this.sortText = "z-".concat(snippet.prefix);
    this.range = range;
  }
  _createClass(MonacoSnippetSuggestion, [{
    key: "resolve",
    value: function resolve() {
      if (!this.resolved) {
        var codeSnippet = new monaco.snippetParser.SnippetParser().parse(this.snippet.body).toString();
        this.documentation = {
          value: "```\n".concat(codeSnippet, "```")
        };
        this.resolved = true;
      }
      return this;
    }
  }], [{
    key: "compareByLabel",
    value: function compareByLabel(a, b) {
      if (a.label > b.label) return 1;
      if (a.label < b.label) return -1;
      return 0;
    }
  }]);
  return MonacoSnippetSuggestion;
}();

var _class;
/********************************************************************************
 * Copyright (C) 2021 Ant Group and others.
 *
 * Date 2021-07-12 15:09:52.
 * Have a nice day.
 ********************************************************************************/
var SnippetSuggestRegistry_1;
var JsonSerializedSnippet;
(function (JsonSerializedSnippet) {
  function is(obj) {
    return _typeof(obj) === 'object' && 'body' in obj && 'prefix' in obj;
  }
  JsonSerializedSnippet.is = is;
})(JsonSerializedSnippet || (JsonSerializedSnippet = {}));
var SnippetSuggestContribution = Syringe.defineToken('SnippetSuggestContribution');
var SnippetSuggestRegistry = SnippetSuggestRegistry_1 = (_class = /*#__PURE__*/function () {
  function SnippetSuggestRegistry(snippetsSuggestContrbutions) {
    var _this = this;
    _classCallCheck(this, SnippetSuggestRegistry);
    this.snippetsSuggestContrbutions = void 0;
    this.snippets = new Map();
    this.pendingSnippets = new Map();
    this.snippetsSuggestContrbutions = snippetsSuggestContrbutions;
    this.snippetsSuggestContrbutions.getContributions().forEach(function (contribution) {
      contribution.registerSnippetSuggest(_this);
    });
  }
  _createClass(SnippetSuggestRegistry, [{
    key: "onInitialize",
    value: function onInitialize(core) {
      core.suggest.setSnippetSuggestSupport(this);
    }
  }, {
    key: "provideCompletionItems",
    value: function () {
      var _provideCompletionItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(model, position, context) {
        var _this2 = this;
        var languageId, snippetsForLanguage, pos, lineOffsets, linePrefixLow, endsInWhitespace, word, availableSnippets, suggestions, _loop, _i, _lineOffsets;
        return _regeneratorRuntime().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(position.column >= SnippetSuggestRegistry_1._maxPrefix)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", undefined);
            case 2:
              if (!(context.triggerKind === monaco.languages.CompletionTriggerKind.TriggerCharacter && context.triggerCharacter === ' ')) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return", undefined);
            case 4:
              languageId = model.getLanguageId(); // TODO: look up a language id at the position
              _context2.next = 7;
              return this.loadSnippets(languageId);
            case 7:
              snippetsForLanguage = this.snippets.get(languageId) || [];
              pos = {
                lineNumber: position.lineNumber,
                column: 1
              };
              lineOffsets = [];
              linePrefixLow = model.getLineContent(position.lineNumber).substr(0, position.column - 1).toLowerCase();
              endsInWhitespace = linePrefixLow.match(/\s$/);
              while (pos.column < position.column) {
                word = model.getWordAtPosition(pos);
                if (word) {
                  // at a word
                  lineOffsets.push(word.startColumn - 1);
                  pos.column = word.endColumn + 1;
                  if (word.endColumn - 1 < linePrefixLow.length && !/\s/.test(linePrefixLow[word.endColumn - 1])) {
                    lineOffsets.push(word.endColumn - 1);
                  }
                } else if (!/\s/.test(linePrefixLow[pos.column - 1])) {
                  // at a none-whitespace character
                  lineOffsets.push(pos.column - 1);
                  pos.column += 1;
                } else {
                  // always advance!
                  pos.column += 1;
                }
              }
              availableSnippets = new Set();
              snippetsForLanguage.forEach(availableSnippets.add, availableSnippets);
              suggestions = [];
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var start;
                return _regeneratorRuntime().wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      start = _lineOffsets[_i];
                      availableSnippets.forEach(function (snippet) {
                        if (_this2.isPatternInWord(linePrefixLow, start, linePrefixLow.length, snippet.prefix.toLowerCase(), 0, snippet.prefix.length)) {
                          suggestions.push(new MonacoSnippetSuggestion(snippet, monaco.Range.fromPositions(position.delta(0, -(linePrefixLow.length - start)), position)));
                          availableSnippets.delete(snippet);
                        }
                      });
                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }, _loop);
              });
              _i = 0, _lineOffsets = lineOffsets;
            case 18:
              if (!(_i < _lineOffsets.length)) {
                _context2.next = 23;
                break;
              }
              return _context2.delegateYield(_loop(), "t0", 20);
            case 20:
              _i++;
              _context2.next = 18;
              break;
            case 23:
              if (endsInWhitespace || lineOffsets.length === 0) {
                // add remaining snippets when the current prefix ends in whitespace or when no
                // interesting positions have been found
                availableSnippets.forEach(function (snippet) {
                  suggestions.push(new MonacoSnippetSuggestion(snippet, monaco.Range.fromPositions(position)));
                });
              }
              // disambiguate suggestions with same labels
              suggestions.sort(MonacoSnippetSuggestion.compareByLabel);
              return _context2.abrupt("return", {
                suggestions: suggestions
              });
            case 26:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
      function provideCompletionItems(_x, _x2, _x3) {
        return _provideCompletionItems.apply(this, arguments);
      }
      return provideCompletionItems;
    }()
  }, {
    key: "resolveCompletionItem",
    value: function resolveCompletionItem(item) {
      return item instanceof MonacoSnippetSuggestion ? item.resolve() : item;
    }
  }, {
    key: "loadSnippets",
    value: function () {
      var _loadSnippets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(scope) {
        var pending;
        return _regeneratorRuntime().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              pending = [];
              pending.push.apply(pending, _toConsumableArray(this.pendingSnippets.get(scope) || []));
              pending.push.apply(pending, _toConsumableArray(this.pendingSnippets.get('*') || []));
              if (!pending.length) {
                _context3.next = 6;
                break;
              }
              _context3.next = 6;
              return Promise.all(pending);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
      function loadSnippets(_x4) {
        return _loadSnippets.apply(this, arguments);
      }
      return loadSnippets;
    }()
  }, {
    key: "fromJSON",
    value: function fromJSON(snippets, _ref) {
      var _this3 = this;
      var language = _ref.language,
        source = _ref.source;
      var toDispose = new DisposableCollection();
      this.parseSnippets(snippets, function (name, snippet) {
        var prefix = snippet.prefix,
          body = snippet.body,
          description = snippet.description;
        var parsedBody = Array.isArray(body) ? body.join('\n') : body;
        var parsedPrefixes = Array.isArray(prefix) ? prefix : [prefix];
        if (typeof parsedBody !== 'string') {
          return;
        }
        var scopes = [];
        if (language) {
          if (Array.isArray(language)) {
            scopes.push.apply(scopes, _toConsumableArray(language));
          } else {
            scopes.push(language);
          }
        } else if (typeof snippet.scope === 'string') {
          var _iterator = _createForOfIteratorHelper(snippet.scope.split(',')),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var rawScope = _step.value;
              var scope = rawScope.trim();
              if (scope) {
                scopes.push(scope);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        parsedPrefixes.forEach(function (parsedPrefix) {
          return toDispose.push(_this3.push({
            scopes: scopes,
            name: name,
            prefix: parsedPrefix,
            description: description,
            body: parsedBody,
            source: source
          }));
        });
      });
      return toDispose;
    }
  }, {
    key: "parseSnippets",
    value: function parseSnippets(snippets, accept) {
      if (_typeof(snippets) === 'object') {
        // eslint-disable-next-line guard-for-in
        for (var name in snippets) {
          var scopeOrTemplate = snippets[name];
          if (JsonSerializedSnippet.is(scopeOrTemplate)) {
            accept(name, scopeOrTemplate);
          } else {
            this.parseSnippets(scopeOrTemplate, accept);
          }
        }
      }
    }
  }, {
    key: "push",
    value: function push() {
      var _this4 = this;
      var toDispose = new DisposableCollection();
      for (var _len = arguments.length, snippets = new Array(_len), _key = 0; _key < _len; _key++) {
        snippets[_key] = arguments[_key];
      }
      var _loop2 = function _loop2() {
        var snippet = _snippets[_i2];
        var _iterator2 = _createForOfIteratorHelper(snippet.scopes),
          _step2;
        try {
          var _loop3 = function _loop3() {
            var scope = _step2.value;
            var languageSnippets = _this4.snippets.get(scope) || [];
            languageSnippets.push(snippet);
            _this4.snippets.set(scope, languageSnippets);
            toDispose.push(Disposable.create(function () {
              var index = languageSnippets.indexOf(snippet);
              if (index !== -1) {
                languageSnippets.splice(index, 1);
              }
            }));
          };
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop3();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };
      for (var _i2 = 0, _snippets = snippets; _i2 < _snippets.length; _i2++) {
        _loop2();
      }
      return toDispose;
    }
  }, {
    key: "isPatternInWord",
    value: function isPatternInWord(patternLow, patternPos, patternLen, wordLow, wordPos, wordLen) {
      while (patternPos < patternLen && wordPos < wordLen) {
        if (patternLow[patternPos] === wordLow[wordPos]) {
          patternPos += 1;
        }
        wordPos += 1;
      }
      return patternPos === patternLen; // pattern must be exhausted
    }
  }]);
  return SnippetSuggestRegistry;
}(), _class._maxPrefix = 10000, _class);
SnippetSuggestRegistry = SnippetSuggestRegistry_1 = __decorate([singleton({
  contrib: InitializeContribution
}), __param(0, contrib(SnippetSuggestContribution)), __metadata("design:paramtypes", [Object])], SnippetSuggestRegistry);

/*
 * @Author: 逍杰
 * @Date: 2021-05-26 14:44:25
 * @Description:
 */
var BaseModule = Module(function (register) {
  decorate(injectable(), monaco.contextKeyService.ContextKeyService);
  register({
    token: {
      token: Contribution.Provider,
      named: InitializeContribution
    },
    useDynamic: function useDynamic(ctx) {
      return new InitializeContributionProvider(InitializeContribution, ctx.container);
    },
    lifecycle: Syringe.Lifecycle.singleton
  });
  register(InitializeProvider);
  // 语言 worker 扩展点
  Contribution.register(register, LanguageWorkerContribution);
  register(LanguageWorkerRegistry);
  register(LanguageOptionsRegistry);
  register(DefaultWorkerContribution);
  register(MonacoConfigurationService, {
    lifecycle: Syringe.Lifecycle.singleton,
    useDynamic: function useDynamic(_ref) {
      var container = _ref.container;
      return createMonacoConfigurationService();
    }
  });
  register(monaco.contextKeyService.ContextKeyService, {
    lifecycle: Syringe.Lifecycle.singleton,
    useDynamic: function useDynamic(_ref2) {
      var container = _ref2.container;
      return new monaco.contextKeyService.ContextKeyService(container.get(MonacoConfigurationService));
    }
  });
  Contribution.register(register, EditorHandlerContribution);
  Contribution.register(register, ThemeContribution);
  Contribution.register(register, SnippetSuggestContribution);
  register(SnippetSuggestRegistry);
  register(MixedThemeRegistry, {
    useValue: {}
  });
  register(ThemeRegistry);
  register(EditorProvider, {
    lifecycle: Syringe.Lifecycle.singleton,
    useDynamic: function useDynamic(ctx) {
      return {
        create: function create(node, options) {
          var child = ctx.container.createChild();
          child.register(EditorNode, {
            useValue: node
          });
          child.register(MonacoOptions, {
            useValue: options
          });
          child.register({
            token: IsDiff,
            useValue: false
          });
          child.register(EditorHanlerRegistry);
          child.register(E2Editor);
          return child.get(E2Editor);
        },
        createDiff: function createDiff(node, options) {
          var child = ctx.container.createChild();
          child.register(EditorNode, {
            useValue: node
          });
          child.register(MonacoOptions, {
            useValue: options
          });
          child.register({
            token: IsDiff,
            useValue: true
          });
          child.register(EditorHanlerRegistry);
          child.register(E2Editor);
          return child.get(E2Editor);
        }
      };
    }
  });
});

var dlog$1 = debug.extend('environment');
var MonacoEnvironmentBound = 'MonacoEnvironmentBound';
var MonacoEnvironment = /*#__PURE__*/function () {
  function MonacoEnvironment() {
    _classCallCheck(this, MonacoEnvironment);
  }
  _createClass(MonacoEnvironment, null, [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var start, monacoReady;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              start = new Date().getTime();
              if (!MonacoEnvironment.container) {
                MonacoEnvironment.setContainer(GlobalContainer);
              }
              if (!MonacoEnvironment.loader) {
                MonacoEnvironment.loader = MonacoEnvironment.container.get(MonacoLoader);
              }
              dlog$1('time: load before load call', new Date().getTime() - start);
              monacoReady = MonacoEnvironment.loader.load();
              dlog$1('time: load after load call', new Date().getTime() - start);
              if (!MonacoEnvironment.loader.loaded && !MonacoEnvironment.monaco) {
                monacoReady.then(function (monacoInstance) {
                  dlog$1('time: monacoReady then', new Date().getTime() - start);
                  MonacoEnvironment.monaco = monacoInstance;
                });
              }
              dlog$1('time: load before return call', new Date().getTime() - start);
              return _context.abrupt("return", monacoReady);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var start, _iterator, _step, loader, initialize;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              start = new Date().getTime();
              if (MonacoEnvironment.monaco) {
                _context2.next = 4;
                break;
              }
              _context2.next = 4;
              return MonacoEnvironment.load();
            case 4:
              dlog$1('time: checkload', new Date().getTime() - start);
              window.MonacoEnvironment = {
                getWorkerUrl: function getWorkerUrl(moduleId, label) {
                  var workerRegistry = MonacoEnvironment.container.get(LanguageWorkerRegistry);
                  return workerRegistry.getLanguageWorker(label, moduleId);
                }
              };
              _context2.prev = 6;
              if (!MonacoEnvironment.baseModule) {
                MonacoEnvironment.baseModule = BaseModule;
                MonacoEnvironment.container.load(MonacoEnvironment.baseModule);
              }
              dlog$1('loaders', MonacoEnvironment.loaders.length);
              _iterator = _createForOfIteratorHelper(MonacoEnvironment.loaders);
              _context2.prev = 10;
              _iterator.s();
            case 12:
              if ((_step = _iterator.n()).done) {
                _context2.next = 20;
                break;
              }
              loader = _step.value;
              dlog$1('time: before await loader', new Date().getTime() - start);
              _context2.next = 17;
              return loader(MonacoEnvironment.container);
            case 17:
              dlog$1('time: after await loader', new Date().getTime() - start);
            case 18:
              _context2.next = 12;
              break;
            case 20:
              _context2.next = 25;
              break;
            case 22:
              _context2.prev = 22;
              _context2.t0 = _context2["catch"](10);
              _iterator.e(_context2.t0);
            case 25:
              _context2.prev = 25;
              _iterator.f();
              return _context2.finish(25);
            case 28:
              dlog$1('time: loader all', new Date().getTime() - start);
              MonacoEnvironment.loaders = [];
              initialize = MonacoEnvironment.container.get(InitializeProvider);
              _context2.next = 33;
              return initialize.initialize(MonacoEnvironment.monaco);
            case 33:
              dlog$1('time: init all', new Date().getTime() - start);
              _context2.next = 39;
              break;
            case 36:
              _context2.prev = 36;
              _context2.t1 = _context2["catch"](6);
              console.log(_context2.t1);
            case 39:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[6, 36], [10, 22, 25, 28]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "loadModule",
    value: function () {
      var _loadModule = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(loader) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              MonacoEnvironment.loaders.push(loader);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function loadModule(_x) {
        return _loadModule.apply(this, arguments);
      }
      return loadModule;
    }()
  }]);
  return MonacoEnvironment;
}();
MonacoEnvironment.container = void 0;
MonacoEnvironment.loaders = [];
MonacoEnvironment.monaco = void 0;
MonacoEnvironment.loader = void 0;
MonacoEnvironment.moduleLoadStart = false;
MonacoEnvironment.moduleInitDeferred = new Deferred();
MonacoEnvironment.baseModule = void 0;
MonacoEnvironment.setContainer = function (container) {
  MonacoEnvironment.container = container;
  if (!container.isBound(MonacoEnvironmentBound)) {
    container.register(MonacoEnvironmentBound, {
      useValue: true
    });
    MonacoEnvironment.container.register(MonacoLoaderConfig, {
      useValue: DefaultLoaderConfig
    });
    container.register(MonacoLoader);
  }
};

var Editor = /*#__PURE__*/_createClass(function Editor(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  _classCallCheck(this, Editor);
  this.editor = void 0;
  this.codeEditor = void 0;
  var editorProvider = MonacoEnvironment.container.get(EditorProvider);
  this.editor = editorProvider.create(node, options);
  this.codeEditor = this.editor.codeEditor;
});

export { Editor, EditorHanlerRegistry, EditorProvider, InitializeContribution, MixedThemeRegistry, MonacoEnvironment, MonacoLoaderConfig, SnippetSuggestContribution, SnippetSuggestRegistry, ThemeContribution, ThemeRegistry, debug };
